import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { PublicHeader } from "../components/PublicHeader";
import { StatusPanel } from "../components/StatusPanel";
import { Turnstile } from "../components/Turnstile";
import { invokeFunction, isBackendConfigured } from "../lib/supabase";

export function PayoutGuardianPage() {
  const { token = "" } = useParams();
  const [name, setName] = useState("");
  const [accepted, setAccepted] = useState(false);
  const [turnstileToken, setTurnstileToken] = useState("");
  const [state, setState] = useState<"idle" | "busy" | "done">("idle");
  const [error, setError] = useState("");

  async function approve() {
    if (name.trim().length < 2 || !accepted) return setError("Enter your full name and confirm the payout authorization.");
    setState("busy"); setError("");
    try {
      if (!isBackendConfigured) {
        setState("done");
        return;
      }
      await invokeFunction("approve-payout-guardian", { token, guardianName: name, accepted: true, turnstileToken });
      setState("done");
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "Could not approve the payout.");
      setState("idle");
    }
  }

  return (
    <div className="public-page"><PublicHeader /><main id="main-content" className="legal-shell">
      <span className="eyebrow">GUARDIAN PAYOUT AUTHORIZATION</span><h1>Approve this payout request.</h1>
      {state === "done" ? <StatusPanel title="Payout approved" message="The House operations team can now verify and process this request." kind="success" /> : <>
        <p>This approval permits the member’s current payout request. It does not guarantee future work or payment and does not approve future payout destinations.</p>
        <label><span>Guardian full name</span><input className="field" value={name} onChange={(event) => setName(event.target.value)} /></label>
        <label className="check-row"><input type="checkbox" checked={accepted} onChange={(event) => setAccepted(event.target.checked)} />I am the member’s legal guardian and authorize this payout request.</label>
        {error && <StatusPanel title="Check the form" message={error} kind="error" />}
        <Turnstile onToken={setTurnstileToken} />
        <button className="btn primary" disabled={state === "busy"} onClick={approve}>{state === "busy" ? "SAVING…" : "APPROVE PAYOUT"}</button>
      </>}
      <Link className="btn" to="/legal/guardian">READ GUARDIAN TERMS</Link>
    </main></div>
  );
}
